import type { Task } from '@/src/renderer/lib/db/models'

export interface RecurringGroups {
  active: Task[]
  dormant: Task[]
}

/** Nächster Termin zuerst; ohne Termin (Quote, nach Abhaken ohne Datum) ans Ende; dann Titel. */
function byNextDate(a: Task, b: Task): number {
  const aMs = a.startDate ? a.startDate.getTime() : Number.POSITIVE_INFINITY
  const bMs = b.startDate ? b.startDate.getTime() : Number.POSITIVE_INFINITY
  if (aMs !== bMs) return aMs < bMs ? -1 : 1
  return a.title.localeCompare(b.title)
}

/**
 * Die zwei Gruppen der Seite **Wiederkehrend**: **Aktiv** und **Ruhend** (`pausedAt`), beide
 * nach nächstem Termin (CONTEXT.md, Wiederkehrend; entschieden 2026-09-13).
 */
export function groupRecurringTasks(tasks: readonly Task[] | undefined): RecurringGroups {
  const active: Task[] = []
  const dormant: Task[] = []
  for (const task of tasks ?? []) (task.pausedAt ? dormant : active).push(task)
  return { active: active.sort(byNextDate), dormant: dormant.sort(byNextDate) }
}
